/*
 * Copyright (c) Vaisala Oyj. All rights reserved.
 */

import LanguageDetector from 'i18next-browser-languagedetector';
import en from './en.json';
// import fi from './fi.json';
// import de from './de.json';
// import fr from './fr.json';
// import es from './es.json';
// import jp from './jp.json';
// import zh from './zh.json';
// import pt from './pt.json';
// import it from './it.json';
// import sv from './sv.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'en',
    resources: {
      en,
      // fi,
      // de,
      // fr,
      // es,
      // jp,
      // zh,
      // pt,
      // it,
      // sv,
    },
    interpolation: {
      escapeValue: false,
    },
    ns: ['common', 'a-parameter-calculator'],
    defaultNS: 'common',
  });

export default i18n;
